import React, {forwardRef, useEffect, useState} from "react";
import styled from "styled-components";
import useRequestTrackingDetailStyles, { PageTitleDiv, RequestTrackingTable, TopBoxDiv, ProgressBarBox } from "./request-tracking-detail-style";
import QnectButton from "../qnect-ui/qnect-button";
import MaterialUiTable from "../ui/material-ui-table/material-ui-table";
import {
    _getPolicy,
    _getPolicyList,
    _getRequest,
    _retrieveMembers, _retrieveRequestDetail,
    _storePoliciesForUpdate,
    _storePolicyList, _storeRequest,
    _syncMemberList
} from "../../store/policy/service";
import {_getLang, _hideSpinner, _showSpinner} from "../../store/system/service";
import {useHistory, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {_formatDate} from "../../utils/utility";
import moment from "moment";
import useConfig from "../qnect-ui/qnect-config";
import RequestTrackingStatus from "../request-tracking/request-tracking-status";
import {
    AddBox, ArrowDownward,
    Check, ChevronLeft,
    ChevronRight,
    Clear,
    DeleteOutline,
    Edit,
    FilterList,
    FirstPage, LastPage, Remove,
    SaveAlt, Search, ViewColumn
} from "@material-ui/icons";
import MaterialTable from "@material-table/core";
import ScrollToTopButton from "../ui/scroll-to-top/scroll-to-top";


const StyledNameDiv = styled.div`
    color: #003DA5;
    cursor: pointer;
    
`;
const StyledBreadCrumbDiv = styled.div`
    font-family: Inter-Regular;
    font-size: 12px;
    display: flex;
    & > div:first-child {
        border-bottom: 2px solid rgba(98,112,136,0.4);
    }
    
    & > div {
        border-bottom: 2px solid black;
        padding-bottom: 5px;
        cursor: pointer;
    }
`;

const TitleDiv = styled.div`
    margin-top: 48px;
    font-family: Stag-Medium;
    color: #0A1F44;
    font-size: 32px;
`;

const PolicyDiv = styled.div`
    margin-top: 46px;
    box-sizing: border-box;
    height: 157px;
    width: 1251px;
    border: 1px solid #E1E4E8;
    border-radius: 10px;
    background-color: #FFFFFF;
    box-shadow: 2px 2px 8px 0 rgba(20,40,75,0.2);

    @media (max-width: 1251px) and (min-width: 1024px) {
        width: 100%;
    }
    
    & > div.insideDiv {
        margin-top: 32.5px;
        margin-left: 40.5px;
        width: 1041px;
        display: flex;
        
        & > div {
            flex-basis: 100%;
            display: flex;
            
            & > div.iconDiv {
                margin-right: 25px;
            }   
        }
    }
    
    .normal {
        font-size: 16px;
        font-family: Inter-Regular;
    }
    
    .bold {
        font-size: 20px;
        font-family: Inter-Medium;
    }
    
    div.policyNumberDiv > div:first-child {
        margin-bottom: 5px;
    }
`;

const SubsidiaryTitleDiv = styled.div`
    margin-top: 30px;
    font-family: Stag-Medium;
    font-size: 20px;
    color: #0A1F44;
`;

const TableDiv = styled.div`
    margin-top: 36px;
    font-family: Inter-Semibold;
    font-size: 12px
    
    div.tableTitle {
        font-family: Inter-SemiBold;
        font-size: 16px;
        color: #0A1F44;
    }
`;

const RequestTrackingDetail = (props) => {
    const history = useHistory();
    const cfg = useConfig(props.lang);
    const classes = useRequestTrackingDetailStyles(props);
    const [request, setRequest] = useState(props.request);
    const [members, setMembers] = useState(props.request?.members);

    useEffect(() => {
        if (!request.members || request.members.length === 0) {
            props.showSpinner();
            props.retrieveRequestDetail(props.request.id).then((response) => {
                if (response.success) {
                    setMembers(response.data);
                    props.request.members = response.data;
                    props.storeRequest(props.request);
                }
                props.hideSpinner();
            }, () => {
                console.log('no data');
                props.hideSpinner();
            });
        }

    }, []);

    const tableIcons = {
        Add: forwardRef((props, ref) => <AddBox {...props} ref={ref}/>),
        Check: forwardRef((props, ref) => <Check {...props} ref={ref}/>),
        Clear: forwardRef((props, ref) => <Clear {...props} ref={ref}/>),
        Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref}/>),
        DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref}/>),
        Edit: forwardRef((props, ref) => <Edit {...props} ref={ref}/>),
        Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref}/>),
        Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref}/>),
        FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref}/>),
        LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref}/>),
        NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref}/>),
        PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref}/>),
        ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref}/>),
        Search: forwardRef((props, ref) => <Search {...props} ref={ref}/>),
        SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref}/>),
        ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref}/>),
        ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref}/>)
    };

    const columns = [
        {
            title: 'Name',
            field: 'lastName',
        },
        {
            title: 'Action Done',
            field: 'status',
            render: rowData => getStatusLabel(rowData.status)
        }
    ]

    const getStatusLabel = (status) => {
        switch(status) {
            case 'A' : return 'Added';
            case 'D' : return 'Deleted';
            default: return 'Edited';
        }
    }

    return (
        <div className={classes.page_container}>

            <StyledBreadCrumbDiv>
                <div onClick={() => history.push('/requestTracking')}>Request Tracking >&nbsp;</div><div className={classes.activeBreadcrumbLink}>Request Details</div>
            </StyledBreadCrumbDiv>
            
            <PageTitleDiv>
                <span>Request Details</span>
            </PageTitleDiv>

            <TopBoxDiv>
                <div class="top-box-column">
                    <div class="top-box-heading">Request No.</div>
                    <div class="top-box-data">#{ request.requestNo }</div>
                </div>
                <div className="top-box-column">
                    <div className="top-box-heading">Policy Number</div>
                    <div className="top-box-data">{request.policyNumber}</div>
                </div>
                <div class="top-box-column">
                    <div class="top-box-heading">Requester</div>
                    <div class="top-box-data">{ request.requesterName }</div>
                </div>
                <div class="top-box-column">
                    <div class="top-box-heading">Date Requested</div>
                    <div class="top-box-data">{ _formatDate(request.requestedDate) }</div>
                </div>
            </TopBoxDiv>

            <ProgressBarBox>
                <div class="process-bar-heading">Progress Workflow</div>
                <RequestTrackingStatus status={request.status}/>
            </ProgressBarBox>

            <RequestTrackingTable>
                <MaterialTable columns={columns} data={members} title='Request Summary' icons={tableIcons} />
            </RequestTrackingTable>
            
            <QnectButton field="backBtn" onClick={() => {history.push('/requestTracking')}}/>
            <ScrollToTopButton></ScrollToTopButton>

        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        request: _getRequest(state),
        lang: _getLang(state)
    }
}

const mapDispatchToProps = {
    showSpinner: _showSpinner,
    hideSpinner: _hideSpinner,
    storeRequest: _storeRequest,
    retrieveRequestDetail: _retrieveRequestDetail
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RequestTrackingDetail));
